import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TMasterdataListDB, TREQUEST_correctiveReasons } from '@monorepo/types';
import { getBctxItemsOrderWithoutSize, getConfigurations, getSubjectKey } from '../app-master-db/app-master.query';
import { MasterdataUtil } from '@monorepo/utils';

export const selectMasterdataListStore = createFeatureSelector<TMasterdataListDB>('INPUT_APP_MASTERDATA_DB');

export const getAllMasterdataListsInfo = createSelector(
  selectMasterdataListStore,
  (selectMasterdataListStore) => selectMasterdataListStore.allMasterdataListsByBctx,
);

export const getAllMasterdataListsInfoAndBctxOrderKeysAndConf = createSelector(
  selectMasterdataListStore,
  getBctxItemsOrderWithoutSize,
  getConfigurations,
  (selectMasterdataListStore, getBctxItemsOrderWithoutSize, { listConf }) =>
    [selectMasterdataListStore.allMasterdataListsByBctx, getBctxItemsOrderWithoutSize, listConf] as const,
);

export const getSilhouetteKeys = createSelector(
  selectMasterdataListStore,
  (selectMasterdataListStore) => selectMasterdataListStore.silhouetteKeysInfo.keys,
);

export const getSilhouetteKeysInfoAndBctxOrderKeysAndConf = createSelector(
  selectMasterdataListStore,
  getBctxItemsOrderWithoutSize,
  getConfigurations,
  (selectMasterdataListStore, getBctxItemsOrderWithoutSize, { silhouetteConf }) =>
    [selectMasterdataListStore.silhouetteKeysInfo, getBctxItemsOrderWithoutSize, silhouetteConf] as const,
);

export const getDownloadSilhouetteAssetsPayload = createSelector(
  getSubjectKey,
  getSilhouetteKeys,
  (subject_key, silhouetteKeys) => {
    const silhoutteNames = Object.values(silhouetteKeys);
    return MasterdataUtil.getDownloadSilhoutteQueryKey(subject_key, silhoutteNames);
  },
);

export const getLoadCorrectiveReasonsPayload = createSelector(getSubjectKey, (subjectKey) => {
  const payload: TREQUEST_correctiveReasons = {
    query_name: 'get_classification_list_names_by_list_type',
    l_type: 'corrective_reasons_list',
    subject_key: subjectKey,
  };
  return payload;
});

export const getCorrectiveReasonList = createSelector(selectMasterdataListStore, (masterDataListDB) => {
  return masterDataListDB.correctiveReasons.result.length
    ? masterDataListDB.correctiveReasons.result[0].data._list
    : [];
});

export const isCorrectiveReasonsAvailable = createSelector(getConfigurations, (config) => {
  return config.hasCorrectiveActions;
});

export const rcaHierarchicalData = createSelector(selectMasterdataListStore, (masterDataListDB) => {
  return masterDataListDB.rcaHierarchicalData;
});
